/**
 * Decide how a News edition source should open from the Sources sidebar.
 * In-page archive when articleId is present; otherwise external publisher URL.
 */
export function resolveSourceNavigation(source) {
  if (source?.articleId) {
    return { mode: 'in-page', articleId: source.articleId };
  }
  if (source?.url) {
    return { mode: 'external', url: source.url };
  }
  return { mode: 'none' };
}
